import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
    Box,
    Typography,
    Skeleton
} from '@mui/material';
import { explorerApi } from '../../../services/api';
import D3NetworkGraph from '../../../Components/D3NetworkGraph';

const UserNetworkTab = ({ userId }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [graphData, setGraphData] = useState({ nodes: [], links: [] });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const loadNodeConnections = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await explorerApi.getNodeConnections('user', userId);
            setGraphData(response);
        } catch (err) {
            setError(t('explorer.user.failedToLoadNetworkConnections'));
            console.error('Network load error:', err);
        } finally {
            setLoading(false);
        }
    }, [userId, t]);

    useEffect(() => {
        if (userId) {
            loadNodeConnections();
        }
    }, [userId, loadNodeConnections]);

    const handleNodeClick = (node) => {
        // Navigate to different pages based on node type
        if (node.type === 'user' && node.id !== userId) {
            // Navigate to other user's page
            window.open(`/explorer/user/${ node.originalLabel || node.id }`);
        } else if (node.type === 'address') {
            // Could navigate to address page if implemented
            console.log('Address clicked:', node.originalLabel || node.id);
        } else if (node.type === 'transaction') {
            window.open(`/explorer/transaction/${ node.id.replace('tx_', '') }`);
        }
    };

    return (
        <Box>
            <Typography variant="h6" gutterBottom>
                {loading ? (
                    <Skeleton variant="text" width={300} height={28} />
                ) : (
                    t('networkConnectionsSubtitle')
                )}
            </Typography>
            {error ? (
                <Box sx={{ p: 2, textAlign: 'center' }}>
                    <Typography color="error">{error}</Typography>
                </Box>
            ) : (
                <D3NetworkGraph
                    userId={userId}
                    graphData={graphData}
                    loading={loading}
                    error={error}
                    onRefresh={loadNodeConnections}
                    onNodeClick={handleNodeClick}
                />
            )}
        </Box>
    );
};

export default UserNetworkTab;
